module.exports = __webpack_public_path__ + "img/greater_fissure_small.0f8dbded.png";